import React from 'react';

const impacts = [
  {
    title: 'Behavior Improvement',
    desc: 'Emotional sentiment tracking and complex case management skills show significant improvement after training with SILO.',
    percent: 78,
    note: '78% improvement in emotional intelligence scores',
  },
  {
    title: 'Confidence in Communication',
    desc: 'Self-efficacy in communicated diagnosis and care plan delivery increases substantially with regular practice.',
    percent: 85,
    note: '85% of users report increased confidence in patient interactions',
  },
];

const ImpactSection: React.FC = () => (
  <section id="impact" style={{ background: '#f6fcfc', padding: '4rem 0', textAlign: 'center' }}>
    <h2 style={{ fontSize: '2.5rem', fontWeight: 800, marginBottom: '1rem', '@media (max-width: 768px)': { fontSize: '2rem' } }}>
      Measurable Impact
    </h2>
    <p style={{ color: '#666', fontSize: '1.25rem', marginBottom: '3rem', maxWidth: '900px', margin: '0 auto 3rem auto', '@media (max-width: 768px)': { fontSize: '1.05rem', marginBottom: '2rem' } }}>
      SILO delivers quantifiable improvements in clinical skills and patient communication.
    </p>
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      gap: '2rem',
      flexWrap: 'wrap',
      maxWidth: 1200,
      margin: '0 auto',
      padding: '0 1rem',
      '@media (max-width: 768px)': {
        flexDirection: 'column',
        gap: '1.5rem',
        alignItems: 'center',
        padding: '0 0.5rem',
      }
    }}>
      {impacts.map((imp, i) => (
        <div key={i} style={{
          flex: '1 1 320px',
          minWidth: 320,
          background: '#fff',
          borderRadius: 16,
          padding: '2rem 1.5rem',
          boxShadow: '0 2px 12px rgba(0,0,0,0.03)',
          textAlign: 'left',
          maxWidth: 500,
          '@media (max-width: 768px)': {
            width: '100%',
            minWidth: 0,
            maxWidth: 500,
            textAlign: 'center',
            padding: '1.25rem 0.75rem',
          }
        }}>
          <div style={{ fontWeight: 700, fontSize: '1.25rem', marginBottom: '0.5rem', '@media (max-width: 768px)': { fontSize: '1.05rem' } }}>{imp.title}</div>
          <div style={{ color: '#555', fontSize: '1rem', marginBottom: '1.5rem', '@media (max-width: 768px)': { fontSize: '0.95rem' } }}>{imp.desc}</div>
          <div style={{ background: '#e0e0e0', borderRadius: 8, height: 12, marginBottom: 8 }}>
            <div style={{ width: `${imp.percent}%`, background: '#223A5E', height: 12, borderRadius: 8, transition: 'width 0.6s' }} />
          </div>
          <div style={{ color: '#666', fontSize: '0.95rem', marginTop: 4 }}>{imp.note}</div>
        </div>
      ))}
    </div>
  </section>
);

export default ImpactSection; 